import React, { useEffect, useMemo, useState } from "react";
import MobilePage, { PageContainer } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import PackageList, { PackageListSkeleton } from "./Components/PackageList";
import { useHistory, useLocation } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "../../Components/AppBar";
import { renderRemainingDiscountTime } from "../../../Components/TimeCountDownBox";
import { usePictureSets } from "../../../hooks/usePictureSets";
import { SubjectSelectorSkeleton } from "../../Components/SubjectSelector";
import Box from "@mui/material/Box";
import useSubjectPackageList from "../../../hooks/useSubjectPackageList";
import useRoutes from "@/react/Webshop/hooks/useRoutes";
import Container from "@mui/material/Container";
import SubjectSelect from "@/react/Webshop/Mobile/Components/SubjectSelect";
import useViewItemList from "@/react/Webshop/hooks/useViewItemList";
import {
  PACKAGE_LIST,
  viewedPackagesFromPackageList,
} from "@/react/Webshop/utils/viewedItems";

const useStyles = makeStyles((theme) => ({
  packageOffersHeading: {
    margin: 0,
    marginBottom: theme.spacing(2),
    fontSize: "30px",
    fontWeight: 300,
    textAlign: "center",
    color: theme.palette.primary.dark,
    display: "none",
    "@media screen and (min-height: 700px)": {
      display: "block",
    },
  },
  viewEditPictureSet: {
    textAlign: "center",
  },
  remainingTime: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    textAlign: "center",
    fontSize: "12px",
  },
}));

const PackageListPage = () => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const { currentPictureSet } = usePictureSets();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (location.pathname == "/products/") {
      history.replace("/products/packages/");
    }
  }, [location]);

  const { isLoading, packageInfo } = useSubjectPackageList(
    currentPictureSet,
    i18n.language,
    true,
  );

  const viewedPackages = useMemo(
    () =>
      packageInfo && !isLoading
        ? viewedPackagesFromPackageList(packageInfo.packages)
        : null,
    [packageInfo, isLoading],
  );
  useViewItemList(PACKAGE_LIST, viewedPackages);

  return (
    <MobilePage>
      <AppBar disableBottomMargin />
      <PageContainer>
        {currentPictureSet && (
          <Box mb={4}>
            <SubjectSelect pictureSet={currentPictureSet} />
          </Box>
        )}
        {!currentPictureSet && <SubjectSelectorSkeleton />}
        <h2 className={classes.packageOffersHeading}>
          <Trans>Exclusive deals</Trans>
        </h2>
        {packageInfo && !isLoading && (
          <Container>
            <TimeLimitedPriceCountdown packageInfo={packageInfo} />
            <PackageList packageInfo={packageInfo} />
          </Container>
        )}
        {(!packageInfo || isLoading) && <PackageListSkeleton />}
      </PageContainer>
    </MobilePage>
  );
};

const TimeLimitedPriceCountdown = ({ packageInfo }) => {
  const { t } = useTranslation();
  const [remainingTime, setRemainingTime] = useState(0);
  const classes = useStyles();

  console.log("Countdown", remainingTime, packageInfo);

  useEffect(() => {
    setRemainingTime(packageInfo?.remainingTime || 0);

    const interval = setInterval(() => {
      setRemainingTime((remainingTime) => remainingTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [packageInfo]);

  if (remainingTime <= 0) {
    return null;
  }

  const dangerousExtraPromoText = renderRemainingDiscountTime(
    remainingTime,
    t,
  );

  console.log("Promo text", dangerousExtraPromoText);

  return (
    <Box
      mb={2}
      p={1}
      className={classes.remainingTime}
      dangerouslySetInnerHTML={dangerousExtraPromoText}
    />
  );
};

export default PackageListPage;
